import service from 'services/fetchInterceptor';
import { LoginPayload, ServiceType } from './types';

const authService: ServiceType | any = {};

authService.login = (data: LoginPayload) =>
  service({
    url: '/login',
    method: 'POST',
    data,
    headers: {
      'public-request': 'true',
    },
  });

authService.logout = (data: LoginPayload) =>
  service({
    url: '/logout',
    method: 'POST',
    data,
    headers: {
      'public-request': 'true',
    },
  });

export default authService;
